import { useQuery } from '@tanstack/react-query';
import React, { useEffect } from 'react';
import { PersonDataContext } from '../../../contexts/person-data-context';
import { ApiError, getTasksWithKontent } from './api';
import Tasks, { TaskType } from '..';
import { useParams } from 'react-router-dom';
import { Spinner } from '../../base/spinner';
import { RefreshContext } from '../../../contexts/refresh-context';

export const TasksContainer = () => {
  const { personData } = React.useContext(PersonDataContext);
  const { ntn } = useParams<{ ntn?: string }>();
  const { usingCachedData } = React.useContext(RefreshContext);
  const [initialCacheUsed, setInitialCacheUsed] =
    React.useState(usingCachedData);

  const {
    data: tasksResponse,
    isLoading: tasksLoading,
    error: tasksError,
    refetch: refetchTasks,
  } = useQuery<TaskType[], ApiError>(
    ['getTasksWithKontent', personData?.person?.customerNumber],
    () => getTasksWithKontent(personData!.person!.customerNumber!),
    { retry: false, enabled: !!personData?.person?.customerNumber },
  );

  useEffect(() => {
    if (initialCacheUsed && !usingCachedData) {
      refetchTasks();
      setInitialCacheUsed(false);
    }
  }, [usingCachedData, initialCacheUsed, refetchTasks]);

  if (tasksLoading) {
    return <Spinner key="spinner" />;
  }
  return (
    <>
      {tasksResponse && (
        <Tasks
          data={tasksResponse.filter((t) => t.assigneeId === 2) ?? []}
          tasksError={tasksError}
          routedViaNtn={ntn}
        />
      )}
    </>
  );
};
